import moment from "moment";
import React from "react";
import { formatIndianCurrency } from "../../helper/ConvertValue";
import commoncss from "../../myfin_v2/css/common.module.css";
import bookclosuretablecss from "../../myfin_v2/css/bookclosuretable.module.css";
import tablecss from "../../myfin_v2/css/table.module.css";

const NbfcCashflowFaceValue = ({
  workspaceDate,
  data,
  HandleReference,
  SwitchReferenceTab,
}) => {
  const calculateTotalSub = (cashflowData, faceValueIds, key) => {
    const copy = [...cashflowData];
    const filterByFaceValueId = copy.filter((ele) =>
      faceValueIds.includes(ele.faceValueId)
    );
    const mergedArray = filterByFaceValueId
      .map(({ faceValueData }) => faceValueData)
      .flat();

    const total = mergedArray.reduce((acc, item) => {
      const value = item[key];
      if (value !== null && value !== undefined) {
        if (
          typeof value === "number" ||
          (Array.isArray(value) && value.every((v) => typeof v === "number"))
        ) {
          return (
            acc +
            (Array.isArray(value)
              ? value.reduce((sum, num) => sum + num, 0)
              : value)
          );
        }
      }
      return acc;
    }, 0);

    return formatIndianCurrency(total);
  };

  // 🔹 Split data into groups whenever a "header row" appears
  const splitGroups = [];
  let currentGroup = [];
  let currentHeader = "Particulars";

  data.forEach((faceValue) => {
    if (
      faceValue?.faceValueData?.length > 0 &&
      [1, 5, 6].includes(faceValue.faceValueId)
    ) {
      // The first row of this faceValueData is the header
      const headerRow = faceValue.faceValueData[0];
      if (headerRow) {
        if (currentGroup.length > 0) {
          splitGroups.push({ header: currentHeader, rows: currentGroup });
          currentGroup = [];
        }
        currentHeader = headerRow.particular; // replace table header
      }
    }
    currentGroup.push(faceValue);
  });

  if (currentGroup.length > 0) {
    splitGroups.push({ header: currentHeader, rows: currentGroup });
  }

  return (
    <>
      {splitGroups.map((group, groupIndex) => (
        <div key={groupIndex} className="m-2 mx-3">
          <table
            className={`${bookclosuretablecss.bookClosureTable} ${tablecss.brTable} ${tablecss.highlightTR}`}
            style={{ marginBottom: "2rem" }}
          >
            <thead>
              <tr>
                <th
                  className="text-uppercase"
                  style={{
                    padding: "8px",
                    // minWidth: "6rem",
                    backgroundColor: "#EFF7F0",
                    color: "#33584E",
                    width: "30%",
                  }}
                >
                  {group.header}
                </th>
                <th
                  className="text-uppercase"
                  style={{
                    padding: "8px",
                    // minWidth: "6rem",
                    backgroundColor: "#EFF7F0",
                    color: "#33584E",
                    width: "15%",
                  }}
                >
                  FOR THE PERIOD ENDED{" "}
                  {moment(workspaceDate?.cy).format("DD MMMM YYYY")}
                </th>
                <th
                  className="text-uppercase"
                  style={{
                    padding: "8px",
                    // minWidth: "6rem",
                    backgroundColor: "#EFF7F0",
                    color: "#33584E",
                    width: "15%",
                  }}
                >
                  FOR THE PERIOD ENDED{" "}
                  {moment(workspaceDate?.py).format("DD MMMM YYYY")}
                </th>
                <th
                  className="text-uppercase"
                  style={{
                    padding: "8px",
                    // minWidth: "6rem",
                    backgroundColor: "#EFF7F0",
                    color: "#33584E",
                    width: "12.5%",
                  }}
                >
                  REFERENCES
                </th>
                <th
                  className="text-uppercase"
                  style={{
                    padding: "8px",
                    // minWidth: "6rem",
                    backgroundColor: "#EFF7F0",
                    color: "#33584E",
                    width: "12.5%",
                  }}
                >
                  IND AS REFERENCES
                </th>
                <th
                  className="text-uppercase"
                  style={{
                    padding: "8px",
                    // minWidth: "6rem",
                    backgroundColor: "#EFF7F0",
                    color: "#33584E",
                    width: "12.5%",
                  }}
                >
                  CHECKLIST REFERENCES
                </th>
              </tr>
            </thead>
            <tbody>
              {group.rows.map((faceValue, index, originalArray) => (
                <React.Fragment key={index}>
                  {faceValue?.faceValueData.length > 0 &&
                    faceValue?.faceValueData.map((ele, i) => {
                      const isHeaderRow =
                        [1, 5, 6].includes(faceValue.faceValueId) && i === 0;
                      if (isHeaderRow) return null; // ⛔ skip rendering inside tbody

                      return (
                        <tr key={i}>
                          <td
                            className={`text-left pl-5 border-top-0 border-bottom-0 font-size-16 text-dark ${
                              ele?.isHeading && "custom-font-600"
                            } `}
                          >
                            {ele?.particular}
                          </td>
                          <td className="text-right pr-4 border-top-0 border-bottom-0 font-size-16 ">
                            {formatIndianCurrency(ele?.cy, null, true)}
                          </td>
                          <td className="text-right pr-4 border-top-0 border-bottom-0 font-size-16 ">
                            {formatIndianCurrency(ele?.py, null, true)}
                          </td>
                          <td
                            className={`text-left pl-1 border-top-0 border-bottom-0 font-size-16 ${
                              ele?.refData?.isReference
                                ? `hyper-link-ref cursor-pointer ${tablecss.highlightRow}`
                                : ""
                            } `}
                            onClick={() => SwitchReferenceTab(ele)}
                          >
                            {ele?.refData?.reference}
                          </td>
                          <td className="text-center border-top-0 border-bottom-0 font-size-16 ">
                            <input
                              type="radio"
                              value={"ind_as_reference"}
                              disabled={!ele?.refData?.reference}
                              onChange={(e) => HandleReference(e, index, i)}
                              checked={
                                ele?.refData?.isReference === "ind_as_reference"
                              }
                            />
                          </td>
                          <td className="text-center border-top-0 border-bottom-0 font-size-16 ">
                            <input
                              type="radio"
                              value={"checklist_reference"}
                              disabled={!ele?.refData?.reference}
                              checked={
                                ele?.refData?.isReference ===
                                "checklist_reference"
                              }
                              onChange={(e) => HandleReference(e, index, i)}
                            />
                          </td>
                        </tr>
                      );
                    })}

                  {/* Totals */}
                  {!(
                    faceValue?.faceValueId === 1 || faceValue?.faceValueId === 7
                  ) && (
                    <tr>
                      <td
                        className={`text-left pl-5  border-top-0 border-bottom-0 font-size-14 ${tablecss.highlightRow}`}
                      >
                        {faceValue?.faceValueId === 2
                          ? "Operating profit before working capital changes"
                          : faceValue?.faceValueId === 3
                          ? "Operating profit after working capital changes"
                          : faceValue?.faceValueId === 4
                          ? "Net cash flow from / (used) in operating activities (A)"
                          : faceValue?.faceValueId === 5
                          ? "Net cash  flow from / (used) in investing activities (B)"
                          : faceValue?.faceValueId === 6
                          ? "Net Cash flow from / (used) in financing activities (C)"
                          : faceValue?.faceValueId === 8
                          ? "Total Cash and Cash Equivalents"
                          : ""}
                      </td>
                      <td
                        className={`custom-font-600 font-size-14 text-right pr-4 border-top-0 border-bottom-0 ${tablecss.highlightRow}`}
                      >
                        {faceValue?.faceValueId === 2
                          ? calculateTotalSub(originalArray, [1, 2], "cy")
                          : faceValue?.faceValueId === 3
                          ? calculateTotalSub(originalArray, [1, 2, 3], "cy")
                          : faceValue?.faceValueId === 4
                          ? calculateTotalSub(originalArray, [1, 2, 3, 4], "cy")
                          : faceValue?.faceValueId === 5
                          ? calculateTotalSub(originalArray, [5], "cy")
                          : faceValue?.faceValueId === 6
                          ? calculateTotalSub(originalArray, [6], "cy")
                          : faceValue?.faceValueId === 8
                          ? calculateTotalSub(originalArray, [8], "cy")
                          : ""}
                      </td>
                      <td
                        className={`custom-font-600 font-size-14 text-right pr-4 border-top-0 border-bottom-0 ${tablecss.highlightRow}`}
                      >
                        {faceValue?.faceValueId === 2
                          ? calculateTotalSub(originalArray, [1, 2], "py")
                          : faceValue?.faceValueId === 3
                          ? calculateTotalSub(originalArray, [1, 2, 3], "py")
                          : faceValue?.faceValueId === 4
                          ? calculateTotalSub(originalArray, [1, 2, 3, 4], "py")
                          : faceValue?.faceValueId === 5
                          ? calculateTotalSub(originalArray, [5], "py")
                          : faceValue?.faceValueId === 6
                          ? calculateTotalSub(originalArray, [6], "py")
                          : faceValue?.faceValueId === 8
                          ? calculateTotalSub(originalArray, [8], "py")
                          : ""}
                      </td>
                      <td className={`${tablecss.highlightRow}`}></td>
                      <td className={`${tablecss.highlightRow}`}></td>
                      <td className={`${tablecss.highlightRow}`}></td>
                    </tr>
                  )}

                  {faceValue?.faceValueId === 6 && (
                    <tr>
                      <td className="text-left pl-5 font-size-14 border-top-0 border-bottom-0 ">
                        Net Increase/Decrease in cash and cash equivalent D =
                        (A+B+C)
                      </td>
                      <td className="border-top-0 border-bottom-0 text-right pr-4">
                        {calculateTotalSub(
                          originalArray,
                          [1, 2, 3, 4, 5, 6],
                          "cy"
                        )}
                      </td>
                      <td className="border-top-0 border-bottom-0 text-right pr-4">
                        {calculateTotalSub(
                          originalArray,
                          [1, 2, 3, 4, 5, 6],
                          "py"
                        )}
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  )}

                  {faceValue?.faceValueId === 7 && (
                    <tr>
                      <td className="text-left pl-5 font-size-14 custom-font-600 border-top-0 border-bottom-0 ">
                        Cash and Cash Equivalents - Closing Balance (D) + (E)
                      </td>
                      <td className="border-top-0 border-bottom-0 text-right pr-4 font-size-16 custom-font-600">
                        {calculateTotalSub(
                          originalArray,
                          [1, 2, 3, 4, 5, 6, 7],
                          "cy"
                        )}
                      </td>
                      <td className="border-top-0 border-bottom-0 text-right pr-4 font-size-16 custom-font-600">
                        {calculateTotalSub(
                          originalArray,
                          [1, 2, 3, 4, 5, 6, 7],
                          "py"
                        )}
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </>
  );
};

export default NbfcCashflowFaceValue;
